var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_notification_wrap",attrs:{"id":_vm.id}},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"close",on:{"click":function($event){return _vm.CloseNotification(_vm.id)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }